import { toast } from 'react-toastify';
import { put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { TOGGLE_LOADER } from '../globalReducer';

function errorMessage(response, defaultMessage) {
  toast.error(response.message || response?.data?.message || defaultMessage);
}

export function* apiErrorHandler(e) {
  yield put({ type: TOGGLE_LOADER, payload: { status: true } });
  const { response = { data: {} } } = e;
  if (process.env.NODE_ENV === 'development') {
    console.log({ response, e }, '<== ERROR');
  }
  if (response.status === 401 || response.status === 403) {
    window.localStorage.clear();
    window.localStorage.getItem('__type__') === 'external_contact' ? yield put(push('/contact_login')) : yield put(push('/login'));
    toast.error('You token has expired. Please login again');
  } else if (response.status === 404) {
    errorMessage(response, 'api route not found');
  } else {
    errorMessage(response, window.navigator.onLine ? (e.message ? e.message : 'Something Went Wrong!') : 'Please check your internet connection');
  }
}

export function handleApiError(e) {
  const { response = { data: {} } } = e;
  if (process.env.NODE_ENV === 'development') {
    console.log({ response, e }, '<== ERROR');
  }
  if (response.status === 401) {
    toast.error('You token has expired. Please login again');
  } else if (response.status === 404) {
    errorMessage(response, 'api route not found');
  } else {
    errorMessage(response, window.navigator.onLine ? (e.message ? e.message : 'Something Went Wrong!') : 'Please check your internet connection');
  }
}
